import { ArrowUpRight } from "lucide-react";
import { ADULT_COURSES, SITE } from "../../content";
import { Eyebrow, Reveal } from "./Primitives";

const AdultCard = ({ c, i }) => (
  <Reveal delay={i * 0.08} className="h-full">
    <a
      href={SITE.adultBookingUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`adult-course-${c.slug}`}
      className="course-card group grid h-full overflow-hidden border border-white/15 bg-navy-700/40 transition-[border-color] duration-500 hover:border-white/40 sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]"
    >
      <div className="relative aspect-[16/10] overflow-hidden sm:aspect-auto">
        <img src={c.image} alt={c.alt} loading="lazy" className="course-img absolute inset-0 h-full w-full object-cover" />
      </div>
      <div className="flex flex-col p-6 sm:p-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-300">{c.kicker}</p>
        <h3 className="mt-2 text-2xl font-extrabold tracking-tight text-white">{c.name}</h3>
        <p className="mt-3 text-sm leading-relaxed text-slate-300 sm:text-base">{c.text}</p>
        <span className="mt-auto flex items-center justify-between pt-7 text-sm font-bold text-white">
          Jetzt buchen
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/30 transition-[background-color,color,transform] duration-500 group-hover:rotate-45 group-hover:bg-white group-hover:text-navy">
            <ArrowUpRight className="h-4 w-4" />
          </span>
        </span>
      </div>
    </a>
  </Reveal>
);

export const AdultCourses = () => (
  <section id="erwachsene" data-testid="adult-courses-section" className="bg-navy py-24 text-white sm:py-28">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <Eyebrow dark>Für Erwachsene</Eyebrow>
          <h2 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-[-0.02em] sm:text-5xl">
            Schwimmen lernen <span className="font-light italic text-sky-200">ist keine Altersfrage.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="text-base leading-relaxed text-slate-300 md:text-lg">
            Auch für Erwachsene bieten wir Kurse an – vom Anfängerkurs bis zum Einstieg ins Kraulschwimmen. Termine, Preise und freie Plätze finden Sie in der Kursbuchung.
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-6 lg:grid-cols-2">
        {ADULT_COURSES.map((c, i) => <AdultCard key={c.slug} c={c} i={i} />)}
      </div>
    </div>
  </section>
);
